module.exports = __webpack_public_path__ + "static/media/social.4a67c65b.svg";